export default {
	uploadNewImage: 'Upload a new image',
	download: 'Download',
	background: {
		title: 'Background',
		panel: {
			colour: 'Colour',
			image: 'Image',
			confirm: 'Confirm',
			upload: 'Upload',
		},
	},
	uploadTip: 'Upload your image here',
};
